var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import RightAccordiancontent from "../../CommonComponent/RightAccordiancontent";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import ToggleSwitch from "@frameworks/web/components/generic/SwitchButton/Switch";
import di from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import { useSelector } from "react-redux";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { ExchangeSelect } from "../DefaultExchange";
import Checkbox from "@frameworks/web/components/generic/CheckBoxGeneric";
import { Col, Row } from "react-bootstrap";
import postLoginDi from "@frameworks/web/components/features/PostLoginDashboard/di/servicelocator";
import Toaster from "@frameworks/shared-library/components/Toast/Toast";
import { Link, useNavigate } from "react-router-dom";
import _, { reject } from "underscore";
import disabledtotp from "@frameworks/web/assets/images/features/LoginFlow/externaltotp/disabledotp.svg";
import { HeadingLogin } from "@frameworks/web/components/features/LoginFlow/Common/HeadingLogin";
import authy from "@frameworks/web/assets/images/features/LoginFlow/securelogin/authy.svg";
import googleauthe from "@frameworks/web/assets/images/features/LoginFlow/securelogin/googleauthe.svg";
import lastauthenticator from "@frameworks/web/assets/images/features/LoginFlow/securelogin/lastauthenticator.svg";
import microsoftauthen from "@frameworks/web/assets/images/features/LoginFlow/securelogin/microsoftauthen.svg";
import Bitwarden from "@frameworks/web/assets/images/features/LoginFlow/securelogin/Bitwarden.svg";
import { AppboxContent } from "@frameworks/web/components/features/LoginFlow/MobileAppCode/AppboxContent";
import { useDispatch } from "react-redux";
export var SettingContent = function () {
    var device = DeviceContext();
    var navigate = useNavigate();
    var _a = __read(useState(false), 2), recieveUpdate = _a[0], setrecieveUpdate = _a[1];
    var _b = __read(React.useState(false), 2), deleteToast = _b[0], setDeleteToast = _b[1];
    var _c = __read(useState(false), 2), defaultExchangeDrawer = _c[0], SetdefaultExchangeDrawer = _c[1];
    var _d = useSelector(function (state) { return state.postLogin.IndexDetails; }, _.isEqual), indexList = _d.data, loader = _d.loader, errorData = _d.errorData;
    var _e = __read(useState({
        display: indexList.defExc,
        value: indexList.defExc,
    }), 2), defaultExchangeSelect = _e[0], setDefaultExchangeSelect = _e[1];
    var ExchangeApply = function (exchange) { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        exc: exchange,
                    };
                    return [4 /*yield*/, di.basicProfile
                            .defaultExchangeData(payload)
                            .then(function (data) {
                            SetdefaultExchangeDrawer(false);
                            setDeleteToast(true);
                        })
                            .catch(function (err) {
                            reject(err);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var _f = __read(useState(undefined), 2), whatsappOption = _f[0], setwhatsappOption = _f[1];
    var _g = __read(useState(false), 2), whatsappToggle = _g[0], setwhatsappToggle = _g[1];
    var dispatch = useDispatch();
    var _h = __read(useState(false), 2), isEnabled = _h[0], setIsEnabled = _h[1];
    var accData = JSON.parse(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("acc_data"));
    var _j = __read(useState(false), 2), etotpDrawrer = _j[0], setetotpDrawrer = _j[1];
    var whatsapp = function (status) { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        return __generator(this, function (_a) {
            payload = {
                source: "WEB",
                user_agent: navigator.appName,
                type: "optin",
            };
            payload.type = status ? "optin" : "optout";
            // if (whatsappToggle) {
            //   payload.type = "optin";
            // }
            // if (whatsappOption === "t") {
            //   payload.type = "optout";
            // }
            di.basicProfile
                .whatsappContentDetailsData(payload)
                .then(function (data) {
                if (data.sts) {
                    setwhatsappToggle(status);
                    var accData_1 = JSON.parse(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("acc_data"));
                    accData_1.wtspCnsnt = status ? "t" : "f";
                    accData_1.wtspCnsnt = status ? "t" : "f";
                    if (accData_1.wtspCnsnt === "NA") {
                        accData_1.wtspCnsnt = "NA";
                        accData_1.wtspCnsnt = "NA";
                        localStorage.setItem("acc_data", JSON.stringify(accData_1));
                    }
                    else {
                        accData_1.wtspCnsnt = status ? "t" : "f";
                        localStorage.setItem("acc_data", JSON.stringify(accData_1));
                    }
                }
            })
                .catch(function (err) {
                reject(err);
            });
            return [2 /*return*/];
        });
    }); };
    React.useEffect(function () {
        var _a, _b;
        postLoginDi.postLogin.getIndexDetails();
        var accData = JSON.parse(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("acc_data"));
        setwhatsappOption(accData === null || accData === void 0 ? void 0 : accData.wtspCnsnt);
        if (accData && ((_b = (_a = accData === null || accData === void 0 ? void 0 : accData.accs) === null || _a === void 0 ? void 0 : _a.totpCode) === null || _b === void 0 ? void 0 : _b.etotpEnabled)) {
            setIsEnabled(true);
        }
        if (!(accData === null || accData === void 0 ? void 0 : accData.wtspCnsnt)) {
            setwhatsappToggle(false);
        }
        else if ((accData === null || accData === void 0 ? void 0 : accData.wtspCnsnt) === "f") {
            setwhatsappToggle(false);
        }
        else if ((accData === null || accData === void 0 ? void 0 : accData.wtspCnsnt) === "t") {
            setwhatsappToggle(true);
        }
        else if ((accData === null || accData === void 0 ? void 0 : accData.wtspCnsnt) === "NA") {
            setwhatsappToggle(false);
        }
        else if ((accData === null || accData === void 0 ? void 0 : accData.wtspCnsnt) === "NA") {
            setwhatsappToggle(false);
        }
        // const whatsappstatus = accData?.wtspCnsnt;
        //   whatsappstatus === "t" ? true : false
    }, []);
    React.useEffect(function () {
        setDefaultExchangeSelect({
            display: indexList.defExc,
            value: indexList.defExc,
        });
    }, [indexList]);
    var _k = __read(useState(false), 2), isDefaultExchangeDrawerOpen = _k[0], setIsDefaultExchangeDrawerOpen = _k[1];
    useEffect(function () {
        // Retrieve state from sessionStorage when component mounts
        var storedState = sessionStorage.getItem("defaultExchangeDrawerState");
        if (storedState) {
            setIsDefaultExchangeDrawerOpen(JSON.parse(storedState));
        }
    }, []);
    var handleToggleDefaultExchangeDrawer = function () {
        var newState = !isDefaultExchangeDrawerOpen;
        setIsDefaultExchangeDrawerOpen(newState);
        SetdefaultExchangeDrawer(true);
        sessionStorage.setItem("defaultExchangeDrawerState", JSON.stringify(newState));
    };
    // React.useEffect(() => {
    //   dispatch(mainDi.footer.setShowFooterUi(false));
    //   dispatch(mainDi.footer.updateShowMob_Menu(false));
    //   return () => {
    //     dispatch(mainDi.footer.setShowFooterUi(true));
    //     dispatch(mainDi.footer.updateShowMob_Menu(true));
    //   };
    // }, []);
    return (React.createElement("div", null,
        React.createElement(Toaster, { parentClass: "position-relative margin-toast", show: deleteToast, setShow: setDeleteToast, position: "middle-center", message: "Default Exchange Selected Succesfully" }),
        React.createElement(RightAccordiancontent, { heading: "Change Password", subHeading: "", rightContent: "", rightIcon: true, onClick: function () {
                navigate("/change-password?redirectUrl=/profile");
            }, parentClassName: "border-radius-no" }),
        (accData === null || accData === void 0 ? void 0 : accData.prfId) && (accData === null || accData === void 0 ? void 0 : accData.wtspCnsnt) !== "NA" && (React.createElement(RightAccordiancontent, { heading: "Receive Updates on WhatsApp", subHeading: "Allow us to send you updates about your portfolio, our latest news and research.", rightContent: React.createElement(React.Fragment, null,
                React.createElement(ToggleSwitch, { id: "advanced", name: "advanced", checked: whatsappToggle, onChange: function (check) { return whatsapp(check); }, small: true })), rightIcon: false })),
        !isEnabled ? (React.createElement(React.Fragment, null,
            " ",
            React.createElement(RightAccordiancontent, { heading: "External TOTP", subHeading: "Use authenticator apps for enhanced account security and offline access with TOTP generation.", rightContent: React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null,
                    " ",
                    React.createElement(EdButton, { value: "Enable", btnTyp: "monochrome-light-grey-border", className: "p-2", onClick: function () {
                            navigate("/external-totp?redirectUrl=/profile&etotpFlow=enable");
                        } }))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "aligncenteritem", onClick: function () {
                            setetotpDrawrer(true);
                        } },
                        React.createElement("span", { className: "DMSanN_12_400 txt_primaryGrey" }, "Enable"),
                        React.createElement("span", { className: "edel-icon-arrow-right-big" }))))), rightIcon: false }))) : (React.createElement(React.Fragment, null, device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
            " ",
            React.createElement("div", { className: "right-content-box mgt-15 undefined col-lg-12" },
                React.createElement("div", { className: "left-section" },
                    React.createElement("span", { className: "DMSansNormal_20_400 d-flex justify-content-left align-items-center txt_blackOne1 " }, "External TOTP"),
                    React.createElement("span", { className: "DMSanN_16_400 d-flex justify-content-left align-items-center txt_primaryGrey subhedding-acc line-30" }, "Use authenticator apps for enhanced account security and offline access with TOTP generation."),
                    React.createElement("div", { className: "d-flex gap-100" },
                        React.createElement("div", { className: "setting-content-grid mgt-20" },
                            React.createElement("div", null,
                                React.createElement("img", { src: disabledtotp })),
                            React.createElement("div", { className: "d-flex align-items-start" },
                                React.createElement("div", null,
                                    React.createElement("span", { className: "DMSanN_14_400 txt-midnight-blue d-flex" }, "Authenticator App Status")))),
                        React.createElement("div", { className: " mgt-20" },
                            React.createElement("span", { className: "DMSanN_14_400 txt-nuvama-green d-flex" }, "Enabled"),
                            React.createElement("span", null,
                                React.createElement(Link, { to: "/external-totp?redirectUrl=/profile&etotpFlow=disable", className: "txt-midnight-blue DMSan_14_500\r\n" }, "Disable External TOTP")),
                            React.createElement("span", { className: "d-flex" },
                                React.createElement(Link, { to: "/external-totp?redirectUrl=/profile&etotpFlow=change", className: "txt-midnight-blue DMSan_14_500\r\n" }, "Change Authenticator App")))),
                    React.createElement("div", null))))) : (React.createElement(React.Fragment, null,
            React.createElement(RightAccordiancontent, { subHeading: "", heading: "External TOTP", bothContent: true, rightContent: React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, "Enabled")), onClick: function () {
                    navigate("/etotp-mob");
                }, rightIcon: true, parentClassName: "enabled-external-totp-mob" }))))),
        React.createElement(RightAccordiancontent, { heading: "Alerts", subHeading: "View and edit the list of all the alerts you have set for your stocks.", rightContent: "", rightIcon: true, onClick: function () { return navigate("/alerts"); } }),
        defaultExchangeDrawer && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-basic-profile editprofile-content mb-genericSidebar" },
                React.createElement(GenericDrawer, { show: defaultExchangeDrawer, setShow: SetdefaultExchangeDrawer, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                        React.createElement("label", { className: "term-heading DMSansBold_20_700 txt_blackOne1" }, "Default Exchange")), bodyComp: React.createElement(React.Fragment, null,
                        React.createElement(Col, { lg: 12, className: "px-3" },
                            React.createElement("span", { className: "DMSans_16_500 txt_blackOne1  pt-4 text-left d-flex" }, "Select your default exchange"),
                            React.createElement("span", { className: "DMSanN_14_400 txt_secondary-gray d-flex pt-2 lh-140" }, "Allow us to show search results basis your preference")),
                        React.createElement(Col, { className: "nse-bse-checkbox-block displayFlex common-checkbox-new" },
                            React.createElement("div", { className: "form-check" },
                                React.createElement(Checkbox, { list: ExchangeSelect[0], name: "placeorder", onChange: function () {
                                        setDefaultExchangeSelect(ExchangeSelect[0]);
                                    }, className: "common-checkbox-custom small-checkbox", selected: defaultExchangeSelect.value })),
                            React.createElement("div", { className: "form-check" },
                                React.createElement(Checkbox, { list: ExchangeSelect[1], name: "placeorder", onChange: function () {
                                        setDefaultExchangeSelect(ExchangeSelect[1]);
                                    }, className: "common-checkbox-custom small-checkbox", selected: defaultExchangeSelect.value }))),
                        React.createElement(Row, { className: "px-3 pb-3 pt-3" },
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: "w-100 px-0 DMSan_14_700 cancel-button-size", onClick: function () {
                                        SetdefaultExchangeDrawer(false);
                                    } })),
                            React.createElement(Col, { className: "col-6" },
                                React.createElement(EdButton, { disabled: !(defaultExchangeSelect === null || defaultExchangeSelect === void 0 ? void 0 : defaultExchangeSelect.value), btnTyp: "midnight-blue", value: "Apply", className: "w-100 px-0 cancel-button-size DMSan_14_700", onClick: function () {
                                        var _a;
                                        return ExchangeApply((_a = defaultExchangeSelect === null || defaultExchangeSelect === void 0 ? void 0 : defaultExchangeSelect.value) === null || _a === void 0 ? void 0 : _a.toString());
                                    } })))) })))),
        etotpDrawrer && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mb-basic-profile drawer-height mb-genericSidebar" },
                React.createElement(GenericDrawer, { parentClass: "bg-transaprent-drawer z-index-high blur-bg  height-setting-drawer", show: etotpDrawrer, setShow: setetotpDrawrer, headerComp: React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "d-center-end px-3 sticky-content-close" },
                            React.createElement("button", { type: "button", className: "edel-icon-bold-close", onClick: function () {
                                    setetotpDrawrer(false);
                                } },
                                React.createElement("i", { className: "" })))), bodyComp: React.createElement(React.Fragment, null,
                        React.createElement(Row, { className: "mx-0 px-3 mgt-20" },
                            React.createElement(Col, { lg: 12, className: "px-0 text-center" },
                                React.createElement(HeadingLogin, { title: "Switch to External TOTP ?" })),
                            React.createElement(Col, { lg: 12, className: "px-0 mgt-20 text-center" },
                                React.createElement("span", { className: "DMSanN_14_400" }, "TOTP allows secure login via rapidly changing codes from your phone or apps that supports TOTP.")),
                            React.createElement(Col, { lg: 12, className: "px-0 mgt-20" },
                                React.createElement("div", { className: "switch-otp-box" },
                                    React.createElement("ul", { className: "list-style-type-disc ps-0" },
                                        React.createElement("li", { className: "DMSanN_14_400 txt-midnight-blue" }, "Ensure security with 6-digit TOTPs using recommended Authenticator apps.")),
                                    React.createElement("span", { className: "DMsanR_11_400 txt_primaryGrey" }, "Available on App and Web"),
                                    React.createElement("div", { className: "grid-2-1 external-top-mb gap-5-custom mt-3" },
                                        React.createElement(AppboxContent, { img: googleauthe, appname: "Google® Authenticator " }),
                                        React.createElement(AppboxContent, { img: authy, appname: "Authy" }),
                                        React.createElement(AppboxContent, { img: microsoftauthen, appname: "Microsoft® Authenticator" }),
                                        React.createElement(AppboxContent, { img: Bitwarden, appname: "Bitwarden" }),
                                        React.createElement(AppboxContent, { img: lastauthenticator, appname: "Last Pass Authenticator" })),
                                    React.createElement("ul", { className: "list-style-type-disc ps-0 mgt-30" },
                                        React.createElement("li", { className: "DMSanN_14_400 txt-midnight-blue" }, "Nuvama mobile App Code is available even with external TOTP enabled.")))),
                            React.createElement(Col, { lg: 12, className: "px-0 mgt-30 aligncenteritem mb-3" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Enable External TOTP", className: "w-100", onClick: function () {
                                        return navigate("/external-totp?redirectUrl=/profile&etotpFlow=enable");
                                    } })))) }))))));
};
